import cloneDeep from 'lodash/cloneDeep'

export default (state = [], action) => {
  let { type, payload } = action
  switch (type) {
    case 'MARKERS_SET':
      return payload
    case 'MARKER_CREATE':
      let newState = cloneDeep(state)
      newState.push(payload)
      return newState
    case 'MARKER_UPDATE':
      return state.map(item => {
        if (item.id === payload.id) {
          console.log(item, payload)
          const thing = Object.assign(item, payload)
          console.log('assigned', thing)
        }
        return item.id === payload.id ? Object.assign(item, payload) : item
      })
    case 'MARKER_DELETE':
      if (state.find(item => item.id = payload).mapObj) {
        state.find(item => item.id = payload).mapObj().setMap(null)
      }
      return state.filter(item => item.id !== payload)
    case 'MARKER_DELETE_MULTIPLE':
      return state.filter(marker => payload.indexOf(marker.id) === -1)
    case 'LOGOUT':
      return []
    default:
      return state
  }
}
